var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{style:({ marginTop: '20px' })},[_c('CampaignsTable',{attrs:{"dataSource":_vm.events,"loading":_vm.loading},on:{"pagination":_vm.pagination}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }